import styled from 'styled-components';

import { colors } from '@playbookux/playbook-web-core';

const { DARK_BLUE, WHITE } = colors;

const Button = styled.div`
  cursor: pointer;
  border: 1px solid ${DARK_BLUE};
  color: ${(props) => (props.selected ? WHITE : DARK_BLUE)};
  border-radius: 3px;
  background-color: ${(props) => (props.selected ? DARK_BLUE : WHITE)};
  padding: 4px 7px;
  display: flex;
  flex: 1;
  margin: 5px 3.5px 0;
  justify-content: center;
`;

const Container = styled.div`
  display: flex;
`;

export {
  Button,
  Container,
};
